import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "elem-operating" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_comp_form = _resolveComponent("comp-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      ($props.config.type === 'POPUP')
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            style: _normalizeStyle({ background: $props.config.background, color: $props.config.color }),
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.onOperatingPopup($props.item, $props.config.url, $props.config.msg)))
          }, _toDisplayString($props.config.title), 5))
        : ($props.config.type === 'JUMP')
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              style: _normalizeStyle({ background: $props.config.background, color: $props.config.color }),
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.onOperatingJump($props.item, $props.config.url, $props.config.msg)))
            }, _toDisplayString($props.config.title), 5))
          : ($props.config.type === 'REQUEST')
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                style: _normalizeStyle({ background: $props.config.background, color: $props.config.color }),
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.onOperatingRequest($props.config.method, $props.item, $props.config.url, $props.config.msg)))
              }, _toDisplayString($props.config.title), 5))
            : ($props.config.type === 'FORM')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 3,
                  style: _normalizeStyle({ background: $props.config.background, color: $props.config.color }),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.onDisplayForm($props.config, $props.item)))
                }, _toDisplayString($props.config.title), 5))
              : _createCommentVNode("", true),
      ($props.config.type === 'FILE')
        ? (_openBlock(), _createElementBlock("button", {
            key: 4,
            style: _normalizeStyle({ background: $props.config.background, color: $props.config.color }),
            onClick: _cache[4] || (_cache[4] = ($event: any) => ($options.onOperatingFile($props.config, $props.item)))
          }, _toDisplayString($props.config.title), 5))
        : ($props.config.type === 'DOWNLOAD')
          ? (_openBlock(), _createElementBlock("button", {
              key: 5,
              style: _normalizeStyle({ background: $props.config.background, color: $props.config.color }),
              onClick: _cache[5] || (_cache[5] = ($event: any) => ($options.onOperatingDownload($props.item, $props.config)))
            }, _toDisplayString($props.config.title), 5))
          : _createCommentVNode("", true)
    ]),
    _createVNode(_component_comp_form, {
      ref: "comp_form",
      onOnSubmit: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('on-refresh')))
    }, null, 512)
  ]))
}